import type { ComponentProps, FC, ReactNode } from 'react';

import { Link } from '@remix-run/react';

import { COMMUNITY_ROUTES } from '~/constants/community';

interface MemberProfileLinkProps extends Omit<ComponentProps<typeof Link>, 'to'> {
  memberId: string;
  children: ReactNode;
}

/**
 * Links wrapped author content (avatar + name, etc.) to the member's profile page.
 * Always links the canonical /members/{id} URL so the address bar stays shareable;
 * /members/me exists only as a redirecting alias for "your own profile".
 */
export const MemberProfileLink: FC<MemberProfileLinkProps> = ({ memberId, children, ...props }) => {
  return (
    <Link to={COMMUNITY_ROUTES.member(memberId)} {...props}>
      {children}
    </Link>
  );
};
